export const PatientInjuryOptions = [
    { name: 'Burn', description: 'Burn' },
    { name: 'Laceration', description: 'Laceration' },
    { name: 'SkinTearInjury', description: 'Skin Tear / Injury' },
    { name: 'Fracture', description: 'Fracture' },
    { name: 'InjuryDueToUseOfRestraints', description: 'Injury Due to Use of Restraints' },
    { name: 'InjuryDueToElectricShock', description: 'Injury Due to Electric Shock in Facility' },
    { name: 'PatientHarmFailureToCommunicateTestResults', description: 'Patient Harm or Death due to failure to communicate test results' },
    { name: 'PatientHarmContaminatedDrugsDevices', description: 'Patient Harm or Death due to use of contaminated drugs/devices or biologics provided by facility' },
    { name: 'Other', description: 'Other' },
];
